<div class="auction-detail-button-cntr" [ngClass]="configuration.cssClass ?? ''">

    <div class="label-cntr mb-2">

        <h5 style="color: white; font-weight: 300;">{{configuration.label}}</h5>

    </div>

    <div class="price-cntr" *ngIf="configuration.description">

        <h4 style="color: white; font-weight: bold; margin: 0;"> {{configuration.description}} </h4>

    </div>

    <ng-container *ngIf="configuration.price || configuration.buttonLabel; else timeTemplate">

        <div class="price-cntr" *ngIf="configuration.price">

            <h3 style="color: white; font-weight: bold; margin: 0;"> {{configuration.price}} € </h3>

        </div>

        <ng-container *ngIf="configuration.buttonLabel">

            <div class="price-cntr">

                <h3 style="color: white; font-weight: bold; margin: 0;"> {{configuration.buttonLabel}} </h3>

            </div>

        </ng-container>

    </ng-container>
    <ng-template #timeTemplate>

        <div class="time-cntr" *ngIf="configuration.time">
            <cd-timer [countdown]="true" [startTime]="configuration.time" format="hms" maxTimeUnit="hour"></cd-timer>
        </div>

    </ng-template>

</div>
